/**
 * LLM bias charts — soft (e.g. developer) vs alert (reviewer) **colors only**.
 * Layout and radii are shared; palette switches emphasis while sharing graph primaries.
 */
export const BIAS_GRAPH_RED = '#ce3a00';
export const BIAS_GRAPH_GREEN = '#008c46';
export const BIAS_GRAPH_BLUE = '#093f88';

export const BIAS_LLM_SOFT = {
  governanceResidual: BIAS_GRAPH_BLUE,
  verdictReject: BIAS_GRAPH_RED,
  complianceAuditBar: BIAS_GRAPH_BLUE,
  vulnerabilityBehavioral: BIAS_GRAPH_BLUE
} as const;

/** Alarm / audit emphasis (non-developer roles). */
export const BIAS_LLM_ALERT = {
  governanceResidual: BIAS_GRAPH_RED,
  verdictReject: BIAS_GRAPH_RED,
  complianceAuditBar: BIAS_GRAPH_RED,
  vulnerabilityBehavioral: BIAS_GRAPH_RED
} as const;

/** @deprecated use BIAS_LLM_SOFT */
export const BIAS_LLM_DEVELOPER = BIAS_LLM_SOFT;
